module.exports = __webpack_public_path__ + "img/content4-6.6e42653b.webp";